import * as AssetsActions from "./assetsActions";

export default AssetsActions;



// WEBPACK FOOTER //
// ./src/actions/AssetsActions/index.js